<template lang="pug">
  div.noflex(style="flex: none; min-width:0; height:28px; padding-top:5px;text-align:center;")
    div.a(v-if="!editable" :class="{ronly:!editable}") {{row+1}}
    popover.a(ref='po' :width=180, v-else-if="editable")
      span(slot='trigger')
        | {{row+1}}
      | 第{{row+1}}行
      //- div.a(@click='doExpand') 展开
      div
      popover(text='查看权限', :width=150)
        div(v-for="(v,k) in data.permissions")
          div {{k}}: {{v}}
      hr(v-if="opts.rowActions")
      div.a(v-if='opts.insertable' @click='insert' style="font-size:13px;") 在下方插入一行
      div.a(v-if='opts.insertable' @click='batchInsert' style="font-size:13px;") 在下方插入多行
      div.a(v-if="opts.moveable" @click='move' style="font-size:13px;") 将选中的数据移动到下一行
      hr(v-if="opts.insertable")
      div(v-for="v in opts.rowActions")
        a(@click="v.handler(data)" style="font-size:13px;") {{v.text}}
</template>

<script>
// Generated by CoffeeScript 2.3.0
let dateFormat, m

dateFormat = require('dateformat')

export default (m = {
  props: {
    opts: Object,
    data: Object,
    row: Number,
    expanded: Boolean,
  },
  data: function() {
    return {
      editable: true,
    }
  },
  methods: {
    doExpand: function() {
      this.$refs.po.close()
      return this.$emit('doExpand', this.data)
    },
    insert: function() {
      return this.$emit('insert', {
        item: {},
        row: this.data.row + 1,
      })
    },
    batchInsert: function() {
      let i, j, num, ref, results
      num = prompt('请输入插入的行数', 1)
      num = ~~num
      if (num >= 1) {
        results = []
        for (i = j = 1, ref = num; ref >= 1 ? j <= ref : j >= ref; i = ref >= 1 ? ++j : --j) {
          results.push(
            this.$emit('insert', {
              item: {},
              row: this.data.row + i,
            }),
          )
        }
        return results
      }
    },
    move: function() {
      return this.$emit('yell', {
        evt: 'move',
        opts: this.data.row + 1,
      })
    },
  },
  mounted: function() {
    let ref
    this.editable = this.opts.editable
    if (
      (!app.user.角色 || !app.user.角色.includes('管理员')) &&
      this.data.permissions &&
      (this.data.permissions[`${app.user.account}`] === '读取' ||
        (!this.data.permissions[`${app.user.account}`] && this.data.permissions['所有人'] === '读取'))
    ) {
      return (this.editable = false)
    }
  },
})
</script>
